import * as React from "react";
import type { SVGProps } from "react";
const SvgReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m2.5 1.667 1.25 1.25L5 1.667l1.25 1.25 1.25-1.25 1.25 1.25L10 1.667l1.25 1.25 1.25-1.25 1.25 1.25L15 1.667l1.25 1.25 1.25-1.25v16.666l-1.25-1.25-1.25 1.25-1.25-1.25-1.25 1.25-1.25-1.25-1.25 1.25-1.25-1.25-1.25 1.25-1.25-1.25L5 18.333l-1.25-1.25-1.25 1.25zM5.833 6.667h8.334M5.833 10h8.334m-8.334 3.333h8.334"
    />
  </svg>
);
export default SvgReceipt;
